import { useQuery } from '@tanstack/react-query';
import { getMe } from 'api/user';
import { meKeys } from 'api/queryKeys';

export const SESSION_KEY = 'session';

export const useMeQuery = () => {
  const hasSession = typeof window !== 'undefined' && !!localStorage.getItem(SESSION_KEY);
  return useQuery({
    queryKey: meKeys.all(),
    queryFn: () => getMe().then((res) => res.data),
    enabled: hasSession,
    retry: false
  });
};
